export default __webpack_public_path__ + "static/media/discord.c7d781b9.svg";